import { create } from 'zustand'
import { CourseState } from './CourseState'

export const useCourseStore = create<CourseState>()(
  (setter) => new CourseState(setter)
)

export function useVolume(){
    const volume:number = useCourseStore((state:CourseState)=>{
      return state.volume
    }) 
    return volume
}
export function useOpenHelpers(){
    const openHelpers:number[] = useCourseStore((state:CourseState)=>{
      return state.openHelpers
    }) 
    return openHelpers
}
export function useSetOpenHelpers(helpers:number[]){
    const setter:Function = useCourseStore((state:CourseState)=>{
        return state.setOpenHelpers
    })
    setter(helpers)
}